import React, { useState } from "react";
import { Container, Table, Image, Modal, Button, Alert, Spinner } from 'react-bootstrap';
import Switch from '@mui/material/Switch';
import { Link } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext";
import axios from "axios";

const BASE = "https://us-central1-inprojuy-f1173.cloudfunctions.net/app";
const ADMIN_EMAIL = "ricardoperezlindo@gmail.com";

const AutoexcluidosDetalle = ({ autoexcluidoData, showModal, modalImageSrc, handleModalShow, handleModalClose }) => {
  const formatFechaHora = (marcaDeTiempo) => {
    const fecha = new Date(marcaDeTiempo);
    const opciones = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'UTC',
    };
    return new Intl.DateTimeFormat('es-AR', opciones).format(fecha);
  };

  const renderValorAnterior = (valorAnterior) => {
    if (typeof valorAnterior === 'boolean') {
      return valorAnterior ? 'Sí' : 'No';
    } else if (typeof valorAnterior === 'string') {
      if (/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(valorAnterior)) {
        return (
          <span className="link" onClick={() => handleModalShow(valorAnterior)}>
            Ver valor anterior
          </span>
        );
      } else {
        return <span>{valorAnterior}</span>;
      }
    } else {
      return <span>{valorAnterior}</span>;
    }
  };

  const renderValorActual = (valorActual) => {
    if (typeof valorActual === 'boolean') {
      return valorActual ? 'Sí' : 'No';
    } else if (typeof valorActual === 'string') {
      if (/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(valorActual)) {
        return (
          <span className="link" onClick={() => handleModalShow(valorActual)}>
            Ver valor actual
          </span>
        );
      } else {
        return <span>{valorActual}</span>;
      }
    } else {
      return <span>{valorActual}</span>;
    }
  };

  const [loading, setLoading] = useState(false);
  const [dryRunLoading, setDryRunLoading] = useState(false);
  const [feedback, setFeedback] = useState(null); // { type: 'success'|'danger'|'info', message, detail? }

  const auth = useAuth();

  const registrarIntento = async (dryRun = false) => {
    if (!auth.user || !autoexcluidoData?.id) return;

    const setSetter = dryRun ? setDryRunLoading : setLoading;
    setSetter(true);
    setFeedback(null);

    try {
      const { data } = await axios.post(`${BASE}/registrar-intento-ingreso`, {
        autoexcluidoId: autoexcluidoData.id,
        dryRun,
      });

      if (dryRun) {
        setFeedback({
          type: 'info',
          message: `[Prueba] Mail enviado a ${data.mailEnviadoA}. En el flujo real se notificaría a ${data.destinatarios.length} destinatario(s):`,
          detail: data.destinatarios.join(', '),
        });
      } else {
        setFeedback({
          type: 'success',
          message: `Intento registrado correctamente. Notificaciones enviadas a ${data.correosEnviados.length} destinatario(s).`,
        });
      }
    } catch (error) {
      const msg = error.response?.data?.message || error.message || "Error desconocido";
      setFeedback({ type: 'danger', message: `Error: ${msg}` });
    } finally {
      setSetter(false);
    }
  };

  return (
    <div className="container-fluid py-4 fondotransparente5" style={{ minHeight: '100vh', paddingBottom: 80 }}>
      <Container style={{ height: '100%', width: '100%', maxWidth: 600, padding: 0 }}>
        <div style={{ height: '100%', width: '100%' }}>
          <div style={{ textAlign: 'center', marginBottom: 12 }}>
            <h2 className="botonbordeazul text-white px-3 py-2 mb-3" style={{ fontSize: 22, borderRadius: 10 }}>Detalle del Autoexcluido</h2>
          </div>
          {autoexcluidoData && (
            <>
              <hr style={{ margin: '10px 0' }} />
              <div style={{ textAlign: 'center', marginBottom: 16 }}>
                <Image
                  src={autoexcluidoData.fotos.filter((foto) => foto !== null).pop() || ''}
                  alt={`Foto de ${autoexcluidoData.nombre}`}
                  fluid
                  style={{
                    width: 'min(80vw, 260px)',
                    height: 'min(80vw, 260px)',
                    maxWidth: 260,
                    maxHeight: 260,
                    objectFit: 'cover',
                    borderRadius: 14,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.10)'
                  }}
                  onClick={() => handleModalShow(autoexcluidoData.fotos.filter((foto) => foto !== null).pop() || '')}
                />
              </div>
              <ul style={{
                fontSize: '1.08em',
                padding: 0,
                listStyle: 'none',
                margin: 0,
                maxWidth: 420,
                marginLeft: 'auto',
                marginRight: 'auto',
                lineHeight: 1.35
              }}>
                <li><strong>Nombre:</strong> {autoexcluidoData.nombre}</li>
                <li><strong>DNI:</strong> {autoexcluidoData.dni}</li>
                <li><strong>Email:</strong> {autoexcluidoData.mail}</li>
                <li><strong>Domicilio:</strong> {autoexcluidoData.domicilio}</li>
                <li><strong>Nacionalidad:</strong> {autoexcluidoData.nacionalidad}</li>
                <li><strong>Teléfono:</strong> {autoexcluidoData.telefono}</li>
                <li><strong>Teléfono de Apoyo:</strong> {autoexcluidoData.telefonoApoyo}</li>
                <li><strong>Ocupación:</strong> {autoexcluidoData.ocupacion}</li>
                <li><strong>Localidad:</strong> {autoexcluidoData.localidad}</li>
                <li><strong>Fecha de Nacimiento:</strong> {autoexcluidoData.fechaNacimiento}</li>
                <li><strong>Activo:</strong> <Switch checked={autoexcluidoData.activo} /></li>
                <li><strong>Fecha de Alta:</strong> {autoexcluidoData.alta.split('T')[0]}</li>
                <li><strong>Fecha de Vencimiento:</strong> {autoexcluidoData.vencimiento.split('T')[0]}</li>
                <li><strong>Lugar de Entrega:</strong> {autoexcluidoData.lugarEntrega}</li>
              </ul>

              {autoexcluidoData.pdfDocument && autoexcluidoData.pdfDocument.length > 0 && (
                <>
                  <h3>Documentos Adjuntos:</h3>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Documento</th>
                        <th>Pdf</th>
                      </tr>
                    </thead>
                    <tbody>
                      {autoexcluidoData.pdfDocument.map((documento, index) => (
                        <tr key={index}>
                          <td>{documento.nombredoc}</td>
                          <td>
                            <a href={documento.url} target="_blank" rel="noopener noreferrer">Ver PDF</a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}

              {autoexcluidoData.observaciones && autoexcluidoData.observaciones.length > 0 && (
                <>
                  <h3>Observaciones:</h3>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Observación</th>
                      </tr>
                    </thead>
                    <tbody>
                      {autoexcluidoData.observaciones.map((observacion, index) => (
                        <tr key={index}>
                          <td>{observacion.fecha.split('T')[0]}</td>
                          <td>{observacion.observacion}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}

              {autoexcluidoData.cambios && autoexcluidoData.cambios.length > 0 && (
                <>
                  <h3>Historial de Cambios:</h3>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Tipo de Cambio</th>
                        <th>Fecha y Hora</th>
                        <th>Usuario</th>
                        <th>Valor Anterior</th>
                        <th>Valor Actual</th>
                      </tr>
                    </thead>
                    <tbody>
                      {autoexcluidoData.cambios.map((cambio, index) => (
                        <tr key={index}>
                          <td>{cambio.tipo}</td>
                          <td>{formatFechaHora(cambio.marcaDeTiempo)}</td>
                          <td>{cambio.usuario}</td>
                          <td>{renderValorAnterior(cambio.valorAnterior)}</td>
                          <td>{renderValorActual(cambio.valorActual)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, margin: '18px 0 8px 0', alignItems: 'center' }}>
                {feedback && (
                  <Alert
                    variant={feedback.type}
                    onClose={() => setFeedback(null)}
                    dismissible
                    style={{ width: '100%', maxWidth: 480, fontSize: 14 }}
                  >
                    <div>{feedback.message}</div>
                    {feedback.detail && (
                      <div style={{ fontSize: 12, marginTop: 6, color: '#555', wordBreak: 'break-all' }}>
                        {feedback.detail}
                      </div>
                    )}
                  </Alert>
                )}

                <Link
                  to={`/ModificarAutoexcluido/${autoexcluidoData.dni}`}
                  style={{
                    background: '#fff',
                    color: '#1976d2',
                    border: '2px solid #1976d2',
                    borderRadius: 8,
                    fontWeight: 600,
                    fontSize: 16,
                    padding: '7px 28px',
                    textDecoration: 'none',
                    boxShadow: '0 1px 6px rgba(25,118,210,0.07)'
                  }}
                >
                  Editar
                </Link>

                <button
                  onClick={() => registrarIntento(false)}
                  disabled={loading || dryRunLoading}
                  style={{
                    background: '#1976d2',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 8,
                    fontSize: 16,
                    padding: '10px 18px',
                    fontWeight: 600,
                    width: '100%',
                    maxWidth: 320,
                    boxShadow: '0 2px 8px rgba(25,118,210,0.08)',
                    cursor: loading || dryRunLoading ? 'not-allowed' : 'pointer',
                  }}
                >
                  {loading
                    ? <Spinner animation="border" size="sm" />
                    : "Registrar Asistencia a Agencia o Sala de Juego"
                  }
                </button>

                {auth.user === ADMIN_EMAIL && (
                  <button
                    onClick={() => registrarIntento(true)}
                    disabled={loading || dryRunLoading}
                    style={{
                      background: 'transparent',
                      color: '#888',
                      border: '1.5px dashed #bbb',
                      borderRadius: 8,
                      fontSize: 13,
                      padding: '6px 16px',
                      fontWeight: 500,
                      width: '100%',
                      maxWidth: 320,
                      cursor: loading || dryRunLoading ? 'not-allowed' : 'pointer',
                    }}
                  >
                    {dryRunLoading
                      ? <Spinner animation="border" size="sm" />
                      : "Probar (sin enviar)"
                    }
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </Container>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Imagen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image src={modalImageSrc} alt="Imagen" fluid />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <div style={{
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: '100vw',
        background: 'rgba(255,255,255,0.97)',
        borderTop: '1.5px solid #e0e0e0',
        zIndex: 9999,
        padding: '12px 0 10px 0',
        display: 'flex',
        justifyContent: 'center',
        boxShadow: '0 -2px 12px rgba(0,0,0,0.07)'
      }}>
        <Button
          variant="primary"
          onClick={handleModalClose}
          style={{
            background: '#1976d2',
            border: 'none',
            borderRadius: 8,
            fontSize: 18,
            fontWeight: 600,
            padding: '10px 38px',
            boxShadow: '0 2px 8px rgba(25,118,210,0.10)'
          }}
        >
          Cerrar
        </Button>
      </div>
    </div>
  );
};

export default AutoexcluidosDetalle;
